export default {
    SET_LEADERS: (state, leaders) => {
        state.leaders = leaders
    },

    SET_BUSINESSES: (state, businesses) => {
        state.businesses = businesses
    },

    SET_COUNT_BUSINESSES: (state, numberOfBusinesses) => {
        state.numberOfBusinesses = numberOfBusinesses
    },

    SET_COUNT_UNCONFIRMED_BUSINESSES: (state, numberOfUnconfirmedBusinesses) => {
        state.numberOfUnconfirmedBusinesses = numberOfUnconfirmedBusinesses
    },

    SET_COUNT_CLIENTS: (state, numberOfClients) => {
        state.numberOfClients = numberOfClients
    },

    SET_PURCHASE_PROMO_DIALOG: (state, purchasePromo) => {
        state.purchasePromoDialog = purchasePromo
    }
}
